import type { GetCosignQueueSearchParams } from "@/core/types/(api)/cosignature";

export const cosignatureKeys = {
  addendumMeta: (documentId: string) =>
    [...cosignatureKeys.base, "addendum", documentId, "meta"] as const,
  base: ["cosignature"] as const,
  noteHistory: (noteId: string) => [...cosignatureKeys.base, "note", noteId, "history"] as const,
  noteMeta: (documentId: string) => [...cosignatureKeys.base, "note", documentId, "meta"] as const,
  queue: (searchParams?: GetCosignQueueSearchParams) =>
    [...cosignatureKeys.base, "queue", searchParams] as const,
  supervisors: () => [...cosignatureKeys.base, "supervisors"] as const,
} as const;
